import React, { useContext } from 'react'
import { Flex } from 'pcln-design-system'
import Pricebreakers from './Promos/Pricebreakers/Pricebreakers'
import VIPPromo from './Promos/VIP/VIPPromo'
import BootstrapDataContext from '../context/BootstrapDataContext'
import IncredibleTile from './Promos/IncredibleTile/IncredibleTile'

export default function PromoFeatureBox() {
  const {
    isMobile = false,
    signInStatus: { signedIn = false }
  } = useContext(BootstrapDataContext)
  return (
    <Flex my={[1, null, 4]} mx="auto" justifyContent="center">
      <Flex maxWidth={1280} style={{ flex: '0 1 100%' }} px={[0, '20px']}>
        {signedIn ? (
          <VIPPromo isMobile={isMobile} />
        ) : (
          <Pricebreakers isMobile={isMobile} />
        )}
        {!isMobile && <IncredibleTile />}
      </Flex>
    </Flex>
  )
}
